import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getEmulatorHost, isUsingEmulators } from './emulator';

export type SystemStatusResponse = {
  ok: boolean;
  now?: string;
  llm?: {
    provider?: string;
    model?: string;
    ollamaBaseUrl?: string;
    allowMockFallback?: boolean;
    available?: boolean;
    availableMs?: number;
    error?: string;
  };
  firebase?: {
    emulatorEnv?: Record<string, string | undefined>;
    checks?: Record<string, { ok: boolean; detail?: string; ms?: number }>;
  };
  error?: string;
};

function getFunctionsBaseUrl(): string {
  const functions = getFunctions();
  const projectId =
    functions.app.options.projectId ||
    process.env.REACT_APP_FIREBASE_PROJECT_ID ||
    'postmortem-pheonix';
  const region = (functions as any).region || 'us-central1';

  if (isUsingEmulators()) {
    return `http://${getEmulatorHost()}:${process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || '5001'}/${projectId}/${region}`;
  }

  return (functions as any).customDomain || `https://${region}-${projectId}.cloudfunctions.net`;
}

export async function fetchSystemStatus(): Promise<SystemStatusResponse> {
  const baseUrl = getFunctionsBaseUrl();
  const url = `${baseUrl}/systemStatus`;

  const auth = getAuth();
  const token = auth.currentUser ? await auth.currentUser.getIdToken(false) : null;

  const resp = await fetch(url, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  const data = (await resp.json().catch(() => ({}))) as SystemStatusResponse;

  if (!resp.ok) {
    return {
      ...data,
      ok: false,
      error: data?.error || `HTTP ${resp.status}`,
    };
  }

  return data;
}
